import createCrudVuexModule from "@/store/crud";

// Finding Source
export const managementLibraryFindingType = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/finding-type",
  moduleName: "managementLibraryFindingType",
  options: {
    localizedFields: ["name", "description"],
  },
});

export const workspaceLibraryFindingType = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/finding-type",
  moduleName: "workspaceLibraryFindingType",
  options: {
    localizedFields: ["name", "description"],
  },
});

// Finding Sub Source
// export const managementLibraryFindingSubSource = createCrudVuexModule({
//   namespaced: true,
//   path: "/management/library/finding-sub-source",
//   moduleName: "managementLibraryFindingSubSource",
//   options: {
//     localizedFields: ["name", "description"],
//   },
// });

// export const workspaceLibraryFindingSubSource = createCrudVuexModule({
//   namespaced: true,
//   path: "/workspace/library/finding-sub-source",
//   moduleName: "workspaceLibraryFindingSubSource",
//   options: {
//     localizedFields: ["name", "description"],
//   },
// });

// Finding Root Cause
export const managementLibraryFindingRootCause = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/finding-root-cause",
  moduleName: "managementLibraryFindingRootCause",
  options: {
    localizedFields: ["name", "description"],
  },
});

export const workspaceLibraryFindingRootCause = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/finding-root-cause",
  moduleName: "workspaceLibraryFindingRootCause",
  options: {
    localizedFields: ["name", "description"],
  },
});

// Finding Category
export const managementLibraryFindingCategory = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/finding-category",
  moduleName: "managementLibraryFindingCategory",
  options: {
    localizedFields: ["name", "description"],
  },
});

export const workspaceLibraryFindingCategory = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/finding-category",
  moduleName: "workspaceLibraryFindingCategory",
  options: {
    localizedFields: ["name", "description"],
  },
});
